<template>
  <div id="contacto">
    <div class="container-fluid cornered" data-aos="fade-left">
      <div class="row contact-container">
        <div class="col-md-12">
          <h1>{{state.title}}</h1>
        </div>

        <div class="col-md-4" data-aos="fade-in">
          <h3>México</h3>
          <p>Blvd. Abelardo L. Rodríguez #829
            <br> Col. Plutarco Elías Calles, C.P. 21376
            <br> Mexicali, Baja California
            <br> (686) 841 6100 al 03
            <br>
          </p>
          <h3>E.U.A</h3>
          <p>Santoyo Transport LLC
            <br> 2310 Martin Luther King JR Ave.
            <br> Calexico, Ca. 92231
            <br> contacto@transportessantoyo.com
            <br> (760) 690 3629
            <br> Yolanda López Gastelum
            <br>
          </p>

        </div>
        <div class="col-md-4" data-aos="fade-in">
          <h3>{{state.subTitle1}}</h3>
          <form method="POST" action="~/../../../../send-mail.php">
            <input name="nombre" placeholder="Nombre" type="text">
            <input name="email" placeholder="Correo" type="text">
            <input name="asunto" placeholder="Asunto" type="text">
            <textarea placeholder="Mensaje" name="mensaje" id=""></textarea>
            <div style="transform:skew(10deg); background-color:;">
              <button type="submit" v-on:click.prevent="warn('Mensaje Enviado.', $event)" style="background-color:#d51218; color:white; border:0px; padding:10px; width:80px;">{{state.btnSubmit}}</button>
            </div>
          </form>
        </div>
        <div class="col-md-4" data-aos="fade-in">
          <div>
            <h3>{{state.subTitle2}}</h3>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3359.0345365373037!2d-115.37697558431404!3d32.658525081008065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d7722962be5925%3A0x842c3f832fa84681!2sCalzada+Abelardo+L+Rodriguez+829%2C+Pob+Compuertas%2C+Mexicali%2C+B.C.!5e0!3m2!1ses!2smx!4v1495037701479" width="300" height="250" frameborder="0" style="border:0" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var $ = require('jquery')
export default {

  methods: {
    warn: function (message, event) {
      // now we have access to the native event
      var form = document.querySelector('form')
      var dataObj = new FormData(form)
      $.ajax({
        method: 'POST',
        url: '/send-mail.php',
        data: dataObj,
        processData: false,
        contentType: false,
        cache: false,
        success: (a, b, c) => {
          console.log(a)
          console.log(b)
          console.log(c)
          alert(message)
          // this.$emit('show', 1)
          // $('input, textarea').each(function (index, input) {
          // 	$(input).val('')
          // })

          // $.ajax({
          //	method: 'POST',
          //	url: '/send-mail-cliente.php',
          //	data: dataObj,
          //	processData: false,
          //	contentType: false,
          //	cache: false,
          // })
        },
        error: (data) => {
          // this.$emit('show', 0)
          console.log('The message could not be sent')
        }
      })
    }
  },
  components: {
  },
  computed: {
    state() {
      return this.$store.state.activeList.contactPage
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

.contact-container {
  text-align: left;
  padding-left: 50px;
  color: white;
  position: absolute;
  left: 10%;
  top: 30px;
}

form {
  color: black;
}

input {
  display: block;
  width: 100%;
  margin-top: 20px;
}

textarea {
  width: 100%;
  margin-top: 20px;
  height: 100px;
}

.cornered {
  margin-left: 10%;
  width: 90%;
  box-sizing: border-box;
  border-bottom: 35em solid $azul;
  border-left: 7em solid transparent;
}

@media screen and (max-width:1400px) {
  .contact-container {
    width: 100%;
    text-align: left;
    padding-left: 0px;
    padding: 10px;
    color: white;
    position: absolute;
    left: 0%;
    top: 50px;
    background-color: $azul;
  }

  .cornered {
    margin-left: 0%;
    width: 100%;
    box-sizing: none;
    border-bottom: 0em solid $azul;
    border-left: 0em solid transparent;
  }
}
</style>



// WEBPACK FOOTER //
// ContactoPage.vue?5637003d